

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/therapien/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/7.0-kV0Tc8.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/7.qusbvrdn.css"];
export const fonts = [];
